import v1 from './v1'
import v2 from './v2'

export default [
  {
    version: '2022.07.22',
    html: v2
  },
  {
    version: '2021.09.15',
    html: v1
  }
]
